import React, { useState, useCallback } from 'react';
import IconButton from '@mui/material/IconButton';
import { withStyles } from '@mui/styles';
import { enqueueSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import RelatedDocumentsDialog from "./RelatedDocumentsDialog";
import { getFieldConfig } from "../../common/helper";

const styles = theme => ({});

const RelatedDocumentsButton = (props) => {
    const {
        userDetails,
        documentDetails,
        folderDetails,
        actionsConfig,
        searchConfig,
        metadataConfig,
        triggerRefreshAuthToken
    } = props;

    const [showDialog, setShowDialog] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    const handleCloseDialog = useCallback(() => {
        setShowDialog(false);
    }, []);

    const handleClickIcon = useCallback((event) => {
        window.location.pathname.toLowerCase().includes("debug") &&
        console.log('handleClickIcon - folderDetails=', folderDetails);

        const queryParams = searchConfig.box.queryParams.concat(
            actionsConfig.relatedDocuments.additionalQueryParams
        );

        // Check if value exists on document details
        let requiredSearchFieldsAvailable = true;

        for (let i = 0; i < queryParams.length; i++) {
            const { templateKey, metadataKey, mandatory } = queryParams[i];
            const val = documentDetails[`${templateKey}~${metadataKey}`];

            if (!val && mandatory) {
                requiredSearchFieldsAvailable = false;
                const fieldConfig = getFieldConfig(metadataConfig, templateKey, metadataKey);
                enqueueSnackbar(
                    `${fieldConfig.label} value required for related documents search`,
                    { variant: 'error' }
                );
                window.location.pathname.toLowerCase().includes("debug") &&
                console.log(`Unable to find ${templateKey}~${metadataKey} value required for document search`);
            }
        }

        if (requiredSearchFieldsAvailable) {
            setAnchorEl(event.currentTarget);
            setShowDialog(true);
        }
    }, [folderDetails, searchConfig, actionsConfig, documentDetails, metadataConfig]);

    return (
        <>
            <Tooltip title="Related Documents">
                <IconButton
                    aria-label="Menu"
                    aria-owns={anchorEl ? 'simple-menu' : undefined}
                    aria-haspopup="true"
                    onClick={handleClickIcon}
                    size="medium"
                    color="secondary"
                >
                    <i className="material-icons">content_copy</i>
                </IconButton>
            </Tooltip>

            {showDialog &&
                <RelatedDocumentsDialog
                    userDetails={userDetails}
                    actionsConfig={actionsConfig}
                    searchConfig={searchConfig}
                    metadataConfig={metadataConfig}
                    documentDetails={documentDetails}
                    folderDetails={folderDetails}
                    handleCloseDialog={handleCloseDialog}
                    triggerRefreshAuthToken={triggerRefreshAuthToken}
                />
            }
        </>
    );
};

RelatedDocumentsButton.propTypes = {
    userDetails: PropTypes.object.isRequired,
    documentDetails: PropTypes.object.isRequired,
    folderDetails: PropTypes.object.isRequired,
    actionsConfig: PropTypes.object.isRequired,
    searchConfig: PropTypes.object.isRequired,
    metadataConfig: PropTypes.object.isRequired,
    triggerRefreshAuthToken: PropTypes.func.isRequired,
};

export default withStyles(styles)(RelatedDocumentsButton);
